const state = {

}

const getters = {

}

const mutations = {
}

const actions = {
  orderKdTracking ({ rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/order/kd-tracking', { params })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
